var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('div',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.errorMsgAccess))]),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }